export enum ValoresExtremos {
	Precipitacao = 'Precipitação (mm)',
	TemperaturaAr = 'Temperatura do ar (ºC)',
	TemperaturaMaxima = 'Temperatura máxima (ºC)',
	TemperaturaMinima = 'Temperatura mínima (ºC)',
	UmidadeRelativa = 'Umidade relativa do ar (%)',
	PressaoAtmosferica = 'Pressão atmosférica (hPa)',
	Radiacao = 'Radiação solar (W/m2)',
	Evapotranspiracao = 'Evapotranspiração (mm)',
	VelocidadeVento2m = 'Velocidade do vento a 2 metros (m/s)',
	VelocidadeVento10m = 'Velocidade do vento a 10 metros (m/s)',
}
